<template>
  <div v-if="deliverable" id="dupPostSelectionModal" class="modal-edit-deliverable">
    <div class="edit-osmp-deliverable-modal no-focus-visible-outline" tabindex="-1">
      <!-- <div class="departments__wrapper">
        <div class="department-title" v-for="(dept, idx) in deliverable.departments" :key="'post-modal-dept-' + dept.department_id">
          <span v-if="idx > 0">&nbsp;&amp;</span> {{ dept.name }}
        </div>
      </div>

      <h1 class="deliverable-title edit-d-title" style="cursor:default;">
        {{ deliverable.title }}
      </h1>

      <div :class="showModalOptions ? 'open' : ''" class="responsive-edit-modal-controls">
        <button @click="showModalOptions = !showModalOptions" class="btn modal-more-controls">
          <i class="fas" :class="!showModalOptions ? 'fa-arrow-left' : 'fa-arrow-right'"></i>
        </button>
        <button @click="$emit('close')" class="btn close-deliverable-btn">
          <i class="fas fa-times"></i>
        </button>
      </div> -->

      <!-- Header controls -->
      <div class="form-inline dup-post-header-controls mb-2 mt-2">
        
        <!-- Select All / Clear All -->
        <div class="d-flex align-items-center selection-btn-group">
          <button class="btn btn-sm btn-primary mr-2" @click="selectAllFiltered">All</button>
          <button class="btn btn-sm btn-primary mr-3" @click="clearAllPosts">None</button>
          <span class="dup-selection-count" style="font-weight: 700;">{{ selectedCount }} / {{ totalCount }}</span>
        </div>

        <!-- Search -->
        <div class="input-group top-search">
          <input type="text" class="form-control media-calls-search" v-model="searchQuery" placeholder="Search posts..." ref="searchQuery" />
          <div class="input-group-append cursor-pointer">
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
        </div>

        <!-- Filter button -->
        <b-button id="dup-post-filter-btn" class="ml-2 mr-2 header-filter-btns" variant="theme">
          <span>Filter</span>
          <img src="@/csmworkflow/img/filter.svg" />
        </b-button>
        <b-popover triggers="click blur" boundary="window" placement="bottom" target="dup-post-filter-btn" custom-class="deliverable-filter" ref="dupPostFilterPopover">
          <div class="d-flex flex-row">
            <div class="grouped-filter-item">
              <!-- Assigned To -->
              <div class="filter-item item__coordinator">
                <label>Assigned To</label>
                <div class="coordinator-wrap">
                  <multiselect v-model="filterQuery.coordinator" :options="allActiveUsers" :show-labels="false" :multiple="true"
                    open-direction="bottom" label="name" track-by="id" :hide-selected="true" :close-on-select="false" :clear-on-select="false">
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} selected</span>
                    </template>
                  </multiselect>
                </div>
              </div>
              <!-- Social Network -->
              <div class="filter-item item__social_network">
                <label>Social Network</label>
                <div class="social-network-wrap">
                  <multiselect v-model="filterQuery.socialNetwork" :options="socialNetworkOptions" :show-labels="false" :multiple="true"
                    open-direction="bottom" label="network_name" track-by="id" :hide-selected="true" :close-on-select="false" :clear-on-select="false">
                    <template slot="option" slot-scope="props">
                      <div><i :class="'fab fa-'+getSocialNetworkClassLocal(props.option.api_type)"></i> {{ props.option.network_name }}</div>
                    </template>
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} selected</span>
                    </template>
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="grouped-filter-item">
              <!-- Tag -->
              <div class="filter-item item__tag">
                <label>Tag</label>
                <div class="tag-wrap">
                  <multiselect v-model="filterQuery.tag" :options="tagOptions" :show-labels="false" :multiple="true"
                    open-direction="bottom" label="name" track-by="id" :hide-selected="true" :close-on-select="false"
                    :clear-on-select="false" :loading="isTagsLoading" :preserve-search="true" @search-change="onTagSearch">
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} selected</span>
                    </template>
                    <template slot="noOptions">Start typing to find tags.</template>
                    <template slot="noResult">No results.</template>
                  </multiselect>
                </div>
              </div>
              <!-- Department -->
              <div class="filter-item item__department">
                <label>Department</label>
                <div class="tag-wrap">
                  <multiselect v-model="filterQuery.department" :options="departmentOptions" :show-labels="false" :multiple="true"
                    open-direction="bottom" label="name" track-by="id" :hide-selected="true" :close-on-select="false" :clear-on-select="false">
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} selected</span>
                    </template>
                  </multiselect>
                </div>
                <b-form-checkbox class="mt-2 csm-checkbox" v-model="filterQuery.noDepartment">No Department</b-form-checkbox>
              </div>
            </div>
            <!-- Dates -->
            <div class="filter-item item__date">
              <div class="due__created__dates">
                <div>
                  <label class="mt-2">Created</label><br/>
                  <date-range-picker ref="pickerDateCreated" @update="filterQuery.filterByCreatedDate = true" :autoApply="true" v-model="filterQuery.createdDateRange"></date-range-picker>
                </div>
                <div>
                  <label class="mt-lg-2">Post Date</label><br/>
                  <date-range-picker ref="pickerPostDate" @update="filterQuery.filterByPostDate = true" :autoApply="true" v-model="filterQuery.postDateRange"></date-range-picker>
                </div>
              </div>
            </div>
            <div>
              <div class="item__reset">
                <b-button variant="theme" title="Reset All Filters" size="sm" @click="resetFilter"><i class="fas fa-undo"></i></b-button>
              </div>
            </div>
          </div>
          <!-- Active filter badges -->
          <div class="d-none d-md-block mt-3" v-if="hasActiveFilters">
            <label>Click to remove filters:</label><br/>
            <span class="badge badge-primary mr-2 mb-2 cursor-pointer" @click="removeFilter('coordinator', c)" v-for="c in filterQuery.coordinator" :key="'fc-'+c.id">{{ c.name }}</span>
            <span class="badge badge-primary mr-2 mb-2 cursor-pointer" @click="removeFilter('socialNetwork', n)" v-for="n in filterQuery.socialNetwork" :key="'fn-'+n.id"><i :class="'fab fa-'+getSocialNetworkClassLocal(n.api_type)"></i> {{ n.network_name }}</span>
            <span class="badge badge-primary mr-2 mb-2 cursor-pointer" @click="removeFilter('tag', t)" v-for="t in filterQuery.tag" :key="'ft-'+t.id">{{ t.name }}</span>
            <span class="badge badge-primary mr-2 mb-2 cursor-pointer" @click="removeFilter('department', d)" v-for="d in filterQuery.department" :key="'fd-'+d.id">{{ d.name }}</span>
            <span class="badge badge-primary mr-2 mb-2 cursor-pointer" @click="filterQuery.noDepartment = false" v-if="filterQuery.noDepartment">No Department</span>
            <span class="badge badge-primary mr-2 mb-2 cursor-pointer" @click="filterQuery.filterByCreatedDate = false" v-if="filterQuery.filterByCreatedDate">Created: {{ filterQuery.createdDateRange.startDate | moment('MMM DD') }} - {{ filterQuery.createdDateRange.endDate | moment('MMM DD') }}</span>
            <span class="badge badge-primary mr-2 mb-2 cursor-pointer" @click="filterQuery.filterByPostDate = false" v-if="filterQuery.filterByPostDate">Post Date: {{ filterQuery.postDateRange.startDate | moment('MMM DD') }} - {{ filterQuery.postDateRange.endDate | moment('MMM DD') }}</span>
          </div>
        </b-popover>

        <!-- Language switcher -->
        <div class="post-content-switcher-wrapper mr-2" v-if="languages.length > 0">
          <div class="switch-toggle">
            <template v-for="(lang, idx) in languages">
              <input :key="'dup-lang-input-'+idx" class="no-focus-visible-outline" v-model="showPostContentLang" :id="'dup_post_lang_'+idx" name="dup_post_lang" type="radio" :value="lang.id">
              <label :key="'dup-lang-label-'+idx" class="no-focus-visible-outline" :for="'dup_post_lang_'+idx" v-b-tooltip.hover :title="lang.lang_name">{{ lang.lang_code }}</label>
            </template>
            <a class="btn no-focus-visible-outline"></a>
          </div>
          <div class="switch-toggle">
            <template v-for="(network, idx2) in socialNetworkOptions">
              <input :key="'dup-net-input-'+idx2" class="no-focus-visible-outline" v-model="showPostContentNetwork" :id="'dup_post_net_'+idx2" name="dup_post_net" type="radio" :value="network.id">
              <label :key="'dup-net-label-'+idx2" class="no-focus-visible-outline" :for="'dup_post_net_'+idx2" v-b-tooltip.hover :title="network.network_name">
                <i :class="'fab fa-'+getSocialNetworkClassLocal(network.api_type)+' platform-indicator'"></i>
              </label>
            </template>
            <a class="btn no-focus-visible-outline"></a>
          </div>
        </div>
      </div>

      <!-- dtable listing -->
      <div class="deliverable-listing social-media grouped-by-date pt-0">
        <div class="deliverable-block">
          <div class="delv-block-resp">
            <div class="d-flex flex-row dbox-wrapper">
              <div class="dbox-left-side dleft-inner-wrap">
                <div class="dtable">
                  <!-- Header row -->
                  <div class="dtr top-row social list-labels">
                    <div class="dtd info-heading titles"><span>Post Name</span></div>
                    <div class="dtd info-heading users"><span>People</span></div>
                    <div class="dtd info-heading publish-date"><span>Number of Posts</span></div>
                    <div class="dtd info-heading caption"><span>Post Copy</span></div>
                    <div class="dtd info-heading thumbnail"><span>Image</span></div>
                    <div class="dtd info-heading social-network"><span>Platforms</span></div>
                    <div class="dtd info-heading languages"><span>EN/FR</span></div>
                  </div>
                  <!-- Empty state -->
                  <div v-if="filteredPosts.length === 0" class="text-center p-4">
                    <p class="text-muted">No posts match your filters.</p>
                  </div>
                  <!-- Grouped post rows (series + solo) -->
                  <template v-for="(group, gIdx) in groupedPosts">
                    <!-- Solo post row (no series) -->
                    <div
                      v-if="!group.isSeries"
                      :key="'dup-post-row-' + group.master.id"
                      class="dtr listing-row"
                      :class="{ 'dup-item-selected': isPostSelected(group.master.id) }"
                      :data-deliverable-id="group.master.id"
                    >
                      <!-- Post Name -->
                      <div class="dtd titles breakpoint__fix">
                        <div class="list-deliverable-status-bar" :style="{ borderLeftColor: getStatusColor(group.master) }"></div>
                        <div class="deliverable-title edit-d-title-stacked delete-bar-left cursor-pointer" @click="toggleSoloPost(group.master)">
                          <b-form-checkbox
                            class="mr-2 dup-item-checkbox d-inline-block"
                            :checked="isPostSelected(group.master.id)"
                            @change="toggleSoloPost(group.master)"
                            @click.native.stop
                          ></b-form-checkbox>
                          <span class="title-text">
                            <span class="link-icon" v-if="isUnlinkedSeriesChild(group.master)">
                              <i class="fas fa-unlink"></i>
                            </span>
                            {{ group.master.title || '(Untitled Post)' }}
                          </span>
                        </div>
                      </div>
                      <!-- People -->
                      <div class="dtd infos users">
                        <span class="info-bubbles" v-if="group.master.coordinator_name">
                          <span class="initials badge badge-primary" :title="group.master.coordinator_name">{{ getInitials(group.master.coordinator_name) }}</span>
                        </span>
                      </div>
                      <!-- Number of Posts -->
                      <div class="dtd infos publish-date">
                        <div class="dup-series-post-count-wrap">
                          <input
                            type="number"
                            class="form-control dup-series-post-count"
                            min="0"
                            :value="getSoloPostCount(group.master)"
                            @click.stop
                            @change="setSoloPostCount(group.master, $event.target.value)"
                          />
                          <span class="dup-series-post-count-total">/ 1</span>
                        </div>
                      </div>
                      <!-- Post Copy -->
                      <div class="dtd infos caption">
                        <div class="char-count" v-html="getCaption(group.master, true)"></div>
                        <div class="caption-text" v-html="getCaption(group.master, false)"></div>
                      </div>
                      <!-- Image, Alt Tag -->
                      <div class="dtd infos thumbnail" v-html="getThumbnailHtml(group.master)"></div>
                      <!-- Platforms -->
                      <div class="dtd infos social-networks">
                        <span class="info-bubbles social-networks">
                          <span
                            v-for="net in group.master.social_networks"
                            :key="'net-'+group.master.id+'-'+net"
                            :class="'social-networks initials badge badge-primary '+getSocialNetworkColorClass(net, group.master)"
                            :title="getSocialNetworkTypeByIdLocal(net)"
                          ><i :class="'fab fa-'+getSocialNetworkClassByIdLocal(net)+' platform-indicator'"></i></span>
                        </span>
                      </div>
                      <!-- Languages -->
                      <div class="dtd infos languages">
                        <span class="info-bubbles languages">
                          <span
                            v-for="lang in group.master.languages"
                            :key="'lang-'+group.master.id+'-'+lang"
                            class="languages initials badge badge-primary"
                            :class="getLangColorClass(lang, group.master)"
                            :title="getLangCodeByIdLocal(lang)"
                          ><span>{{ getLangCodeByIdLocal(lang) }}</span></span>
                        </span>
                      </div>
                    </div>

                    <!-- Series row (master + children inline) -->
                    <div
                      v-else
                      :key="'dup-post-series-' + group.master.id"
                      class="dtr listing-row is-social-series"
                      :class="{ 'dup-item-selected': isPostSelected(group.master.id) }"
                      :data-deliverable-id="group.master.id"
                    >
                      <!-- Post Name (master checkbox) -->
                      <div class="dtd titles breakpoint__fix">
                        <div class="list-deliverable-status-bar" :style="{ borderLeftColor: getStatusColor(group.master) }"></div>
                        <div class="deliverable-title edit-d-title-stacked delete-bar-left cursor-pointer" @click="toggleSeries(group)">
                          <b-form-checkbox
                            class="mr-2 dup-item-checkbox dup-series-checkbox d-inline-block"
                            :checked="isPostSelected(group.master.id)"
                            @change="toggleSeries(group)"
                            @click.native.stop
                          ></b-form-checkbox>
                          <span class="title-text">{{ group.master.title || '(Untitled Post)' }}</span>
                        </div>
                      </div>
                      <!-- People -->
                      <div class="dtd infos users">
                        <span class="info-bubbles" v-if="group.master.coordinator_name">
                          <span class="initials badge badge-primary" :title="group.master.coordinator_name">{{ getInitials(group.master.coordinator_name) }}</span>
                        </span>
                      </div>
                      <!-- Number of Posts -->
                      <div class="dtd infos publish-date">
                        <div class="dup-series-post-count-wrap">
                          <input
                            type="number"
                            class="form-control dup-series-post-count"
                            min="0"
                            :value="getSeriesPostCount(group)"
                            @click.stop
                            @change="setSeriesPostCount(group, $event.target.value)"
                          />
                          <span class="dup-series-post-count-total">/ {{ group.members.length }}</span>
                        </div>
                      </div>
                      <!-- Post Copy -->
                      <div class="dtd infos caption">
                        <div class="char-count" v-html="getCaption(group.master, true)"></div>
                        <div class="caption-text" v-html="getCaption(group.master, false)"></div>
                      </div>
                      <!-- Image, Alt Tag -->
                      <div class="dtd infos thumbnail" v-html="getThumbnailHtml(group.master)"></div>
                      <!-- Platforms -->
                      <div class="dtd infos social-networks">
                        <span class="info-bubbles social-networks">
                          <span
                            v-for="net in group.master.social_networks"
                            :key="'net-'+group.master.id+'-'+net"
                            :class="'social-networks initials badge badge-primary '+getSocialNetworkColorClass(net, group.master)"
                            :title="getSocialNetworkTypeByIdLocal(net)"
                          ><i :class="'fab fa-'+getSocialNetworkClassByIdLocal(net)+' platform-indicator'"></i></span>
                        </span>
                      </div>
                      <!-- Languages -->
                      <div class="dtd infos languages">
                        <span class="info-bubbles languages">
                          <span
                            v-for="lang in group.master.languages"
                            :key="'lang-'+group.master.id+'-'+lang"
                            class="languages initials badge badge-primary"
                            :class="getLangColorClass(lang, group.master)"
                            :title="getLangCodeByIdLocal(lang)"
                          ><span>{{ getLangCodeByIdLocal(lang) }}</span></span>
                        </span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="dup-modal-footer d-flex justify-content-end mt-3">
        <button class="btn btn-primary" @click="$emit('close')">
          Close ({{ selectedCount }} posts selected)
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DuplicatePostSelection",
  props: {
    deliverable: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchQuery: "",
      showModalOptions: false,
      showPostContentLang: null,
      showPostContentNetwork: null,
      captionMaxLength: 280,
      isTagsLoading: false,
      tagOptions: [],
      filterQuery: {
        coordinator: [],
        socialNetwork: [],
        tag: [],
        department: [],
        noDepartment: false,
        createdDateRange: { startDate: null, endDate: null },
        postDateRange: { startDate: null, endDate: null },
        filterByCreatedDate: false,
        filterByPostDate: false,
      },
    };
  },
  computed: {
    ...mapGetters([
      "systemSettings",
      "allActiveUsers",
      "getSocialNetworkClassById",
      "getSocialNetworkTypeById",
      "getSocialNetworkClass",
      "getLangCodeById",
      "authToken",
    ]),
    posts() {
      return this.deliverable.posts || [];
    },
    totalCount() {
      return this.getDisplayPostTotalCount();
    },
    selectedCount() {
      return this.getDisplaySelectedPostCount();
    },
    languages() {
      return (this.systemSettings && this.systemSettings.languages) || [];
    },
    socialNetworkOptions() {
      return (this.systemSettings && this.systemSettings.social_networks) || [];
    },
    departmentOptions() {
      let depts = {};
      this.posts.forEach((p) => {
        if (p.departments) {
          p.departments.forEach((d) => {
            if (!depts[d.department_id]) depts[d.department_id] = { id: d.department_id, name: d.name };
          });
        }
      });
      return Object.values(depts);
    },
    token() {
      return this.authToken;
    },
    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    hasActiveFilters() {
      let f = this.filterQuery;
      return f.coordinator.length > 0 || f.socialNetwork.length > 0 || f.tag.length > 0 || f.department.length > 0 || f.noDepartment || f.filterByCreatedDate || f.filterByPostDate;
    },
    filteredPosts() {
      let result = this.posts.slice();
      let q = this.searchQuery ? this.searchQuery.toLowerCase() : "";
      let f = this.filterQuery;

      // Search
      if (q) {
        result = result.filter((p) => {
          if (p.title && p.title.toLowerCase().includes(q)) return true;
          if (p.template_title && p.template_title.toLowerCase().includes(q)) return true;
          return false;
        });
      }

      // Coordinator filter
      if (f.coordinator.length > 0) {
        let ids = f.coordinator.map((c) => c.id);
        result = result.filter((p) => ids.includes(p.coordinator_id));
      }

      // Social network filter
      if (f.socialNetwork.length > 0) {
        let ids = f.socialNetwork.map((n) => n.id);
        result = result.filter((p) => p.social_networks && p.social_networks.some((nid) => ids.includes(nid)));
      }

      // Tag filter
      if (f.tag.length > 0) {
        let ids = f.tag.map((t) => t.id);
        result = result.filter((p) => p.tags && p.tags.some((t) => ids.includes(t.tag_id)));
      }

      // Department filter
      if (f.department.length > 0) {
        let ids = f.department.map((d) => d.id);
        result = result.filter((p) => p.departments && p.departments.some((d) => ids.includes(d.department_id)));
      }

      // No department
      if (f.noDepartment) {
        result = result.filter((p) => !p.departments || p.departments.length === 0);
      }

      // Created date range
      if (f.filterByCreatedDate && f.createdDateRange.startDate && f.createdDateRange.endDate) {
        let start = this.$moment(f.createdDateRange.startDate).startOf("day");
        let end = this.$moment(f.createdDateRange.endDate).endOf("day");
        result = result.filter((p) => {
          if (!p.created_at) return false;
          let d = this.$moment.utc(p.created_at).local();
          return d.isBetween(start, end, null, "[]");
        });
      }

      // Post date range
      if (f.filterByPostDate && f.postDateRange.startDate && f.postDateRange.endDate) {
        let start = this.$moment(f.postDateRange.startDate).startOf("day");
        let end = this.$moment(f.postDateRange.endDate).endOf("day");
        result = result.filter((p) => {
          if (!p.publish_date) return false;
          let d = this.$moment.utc(p.publish_date).local();
          return d.isBetween(start, end, null, "[]");
        });
      }

      return result;
    },
    groupedPosts() {
      // Group filteredPosts by social_series_id:
      //  - master (is_master=1) + children (is_master=0) that share the same social_series_id
      //  - posts without social_series_id, or series with no master in the filtered set,
      //    become solo rows
      const filtered = this.filteredPosts;
      const seriesMap = {};
      const solo = [];

      filtered.forEach((p) => {
        const sid = p.social_series_id;
        if (!sid || this.isUnlinkedSeriesChild(p)) {
          solo.push(p);
          return;
        }
        if (!seriesMap[sid]) {
          seriesMap[sid] = { master: null, children: [] };
        }
        if (p.is_master) {
          seriesMap[sid].master = p;
        } else {
          seriesMap[sid].children.push(p);
        }
      });

      // Build final grouped list preserving filteredPosts order.
      // Use the position of the master (or first member) in `filtered` as the
      // group's sort anchor so we do not break existing sort.
      const seenSeries = {};
      const result = [];

      filtered.forEach((p) => {
        const sid = p.social_series_id;
        if (!sid || this.isUnlinkedSeriesChild(p)) {
          // Solo post
          result.push({
            isSeries: false,
            master: p,
            children: [],
            members: [p],
          });
          return;
        }
        if (seenSeries[sid]) return;
        seenSeries[sid] = true;

        const group = seriesMap[sid];
        if (!group.master) {
          // Series with no master in filtered set — render each matching child as solo
          group.children.forEach((c) => {
            result.push({
              isSeries: false,
              master: c,
              children: [],
              members: [c],
            });
          });
          return;
        }

        // Series row: master first, then children sorted by publish_date
        const children = group.children.slice().sort((a, b) => {
          const ad = a.publish_date ? new Date(a.publish_date).getTime() : 0;
          const bd = b.publish_date ? new Date(b.publish_date).getTime() : 0;
          return ad - bd;
        });
        result.push({
          isSeries: true,
          master: group.master,
          children: children,
          members: children,
        });
      });

      return result;
    },
  },
  watch: {
    languages() {
      this.setDefaultPostContentFilters();
    },
    socialNetworkOptions() {
      this.setDefaultPostContentFilters();
    },
    deliverable() {
      this.$nextTick(this.setDefaultPostContentFilters);
    },
  },
  mounted() {
    this.setDefaultPostContentFilters();
  },
  methods: {
    setDefaultPostContentFilters() {
      if (this.languages.length > 0 && !this.showPostContentLang) {
        this.showPostContentLang = this.languages[0].id;
      }
      if (this.socialNetworkOptions.length > 0 && !this.showPostContentNetwork) {
        this.showPostContentNetwork = this.socialNetworkOptions[0].id;
      }
    },
    onModalShown() {
      this.setDefaultPostContentFilters();
    },
    isPostSelected(postId) {
      return this.$store.getters.isSocialPostSelected(this.deliverable.id, postId);
    },
    isUnlinkedSeriesChild(post) {
      return !!(post && post.social_series_id && !post.is_master && post.manually_updated_at);
    },
    togglePost(postId) {
      this.$store.commit("TOGGLE_SOCIAL_MEDIA_POST", {
        parentDeliverableId: this.deliverable.id,
        postId: postId,
      });
    },
    toggleSoloPost(post) {
      this.setSoloPostCount(post, this.isPostSelected(post.id) ? 0 : Math.max(1, this.getSoloPostCount(post) || 1));
    },
    toggleSeries(group) {
      const allIds = [group.master.id, ...group.members.map((m) => m.id)];
      if (this.isPostSelected(group.master.id)) {
        // Deselect all (master + children)
        allIds.forEach((id) => {
          if (this.isPostSelected(id)) {
            this.$store.commit("TOGGLE_SOCIAL_MEDIA_POST", {
              parentDeliverableId: this.deliverable.id,
              postId: id,
            });
          }
        });
        this.$store.commit("SET_SOCIAL_MEDIA_POST_COUNT", {
          parentDeliverableId: this.deliverable.id,
          seriesMasterId: group.master.id,
          count: 0,
        });
      } else {
        // Select all (master + children)
        allIds.forEach((id) => {
          if (!this.isPostSelected(id)) {
            this.$store.commit("TOGGLE_SOCIAL_MEDIA_POST", {
              parentDeliverableId: this.deliverable.id,
              postId: id,
            });
          }
        });
        this.$store.commit("SET_SOCIAL_MEDIA_POST_COUNT", {
          parentDeliverableId: this.deliverable.id,
          seriesMasterId: group.master.id,
          count: group.members.length,
        });
      }
    },
    getSelectedPostIds() {
      const posts = this.$store.state.duplicationWizard.selectedSocialMediaPostIds[this.deliverable.id];
      return Array.isArray(posts) ? posts.slice() : [];
    },
    getSeriesMasterIds() {
      return new Set(this.posts.filter((post) => post.social_series_id && post.is_master).map((post) => post.id));
    },
    getDisplayPostTotalCount() {
      return this.posts.filter((post) => !post.social_series_id || !post.is_master).length;
    },
    getDisplaySelectedPostCount() {
      const masterIds = this.getSeriesMasterIds();
      return this.getSelectedPostSequence().filter((postId) => !masterIds.has(postId)).length;
    },
    getSelectedPostSequence() {
      const selectedIds = this.getSelectedPostIds();
      const selectedCounts = this.$store.state.duplicationWizard.selectedSocialMediaPostCounts[this.deliverable.id] || {};
      const seriesMap = {};
      const soloPosts = [];

      this.posts.forEach((post) => {
        const seriesId = post.social_series_id;
        if (!seriesId || this.isUnlinkedSeriesChild(post)) {
          soloPosts.push(post);
          return;
        }
        if (!seriesMap[seriesId]) {
          seriesMap[seriesId] = { master: null, children: [] };
        }
        if (post.is_master) {
          seriesMap[seriesId].master = post;
        } else {
          seriesMap[seriesId].children.push(post);
        }
      });

      let sequence = [];
      soloPosts.forEach((post) => {
        if (!selectedIds.includes(post.id)) return;
        let count = this.getPostCountOverride(selectedCounts, post.id, 1);
        for (let index = 0; index < count; index++) {
          sequence.push(post.id);
        }
      });
      Object.values(seriesMap).forEach((group) => {
        group.children = group.children.slice().sort((a, b) => {
          const aDate = a.publish_date ? new Date(a.publish_date).getTime() : 0;
          const bDate = b.publish_date ? new Date(b.publish_date).getTime() : 0;
          return aDate - bDate;
        });

        if (!group.master) {
          sequence = sequence.concat(group.children.filter((post) => selectedIds.includes(post.id)).map((post) => post.id));
          return;
        }
        if (Object.prototype.hasOwnProperty.call(selectedCounts, group.master.id)) {
          let count = parseInt(selectedCounts[group.master.id], 10);
          if (isNaN(count) || count < 0) count = 0;
          if (count > 0) {
            sequence.push(group.master.id);
            for (let index = 0; index < count && group.children.length > 0; index++) {
              sequence.push(group.children[index % group.children.length].id);
            }
          }
          return;
        }
        if (selectedIds.includes(group.master.id)) {
          sequence.push(group.master.id);
        }
        sequence = sequence.concat(group.children.filter((post) => selectedIds.includes(post.id)).map((post) => post.id));
      });

      return sequence;
    },
    setSelectedPostIds(postIds) {
      this.$store.commit("SET_SOCIAL_MEDIA_POST_IDS", {
        parentDeliverableId: this.deliverable.id,
        postIds: postIds,
      });
    },
    getSeriesPostCount(group) {
      const counts = this.$store.state.duplicationWizard.selectedSocialMediaPostCounts[this.deliverable.id] || {};
      if (Object.prototype.hasOwnProperty.call(counts, group.master.id)) {
        return counts[group.master.id];
      }
      return group.members.filter((member) => this.isPostSelected(member.id)).length;
    },
    getPostCountOverride(counts, postId, fallback) {
      if (Object.prototype.hasOwnProperty.call(counts, postId)) {
        let count = parseInt(counts[postId], 10);
        return isNaN(count) || count < 0 ? 0 : count;
      }
      return fallback;
    },
    getSoloPostCount(post) {
      const counts = this.$store.state.duplicationWizard.selectedSocialMediaPostCounts[this.deliverable.id] || {};
      return this.getPostCountOverride(counts, post.id, this.isPostSelected(post.id) ? 1 : 0);
    },
    setSoloPostCount(post, value) {
      let count = parseInt(value, 10);
      if (isNaN(count)) count = 1;
      count = Math.max(0, count);

      this.$store.commit("SET_SOCIAL_MEDIA_POST_COUNT", {
        parentDeliverableId: this.deliverable.id,
        seriesMasterId: post.id,
        count: count,
      });

      let nextIds = this.getSelectedPostIds().filter((id) => id !== post.id);
      if (count > 0) {
        nextIds.push(post.id);
      }

      this.setSelectedPostIds(Array.from(new Set(nextIds)));
    },
    setSeriesPostCount(group, value) {
      let count = parseInt(value, 10);
      if (isNaN(count)) count = group.members.length;
      count = Math.max(0, count);

      this.$store.commit("SET_SOCIAL_MEDIA_POST_COUNT", {
        parentDeliverableId: this.deliverable.id,
        seriesMasterId: group.master.id,
        count: count,
      });

      const memberIds = group.members.map((member) => member.id);
      const selectedMemberIds = group.members.slice(0, Math.min(count, group.members.length)).map((member) => member.id);
      let nextIds = this.getSelectedPostIds().filter((id) => id !== group.master.id && !memberIds.includes(id));

      if (count > 0) {
        nextIds.push(group.master.id);
        nextIds = nextIds.concat(selectedMemberIds);
      }

      this.setSelectedPostIds(Array.from(new Set(nextIds)));
    },
    selectAllFiltered() {
      this.$store.commit("CLEAR_SOCIAL_MEDIA_POST_COUNTS", this.deliverable.id);
      this.filteredPosts.forEach((p) => {
        if (!this.isPostSelected(p.id)) {
          this.togglePost(p.id);
        }
      });
    },
    clearAllPosts() {
      this.$store.commit("CLEAR_ALL_SOCIAL_POSTS", this.deliverable.id);
    },
    removeFilter(type, item) {
      if (type === "coordinator") {
        this.filterQuery.coordinator = this.filterQuery.coordinator.filter((c) => c.id !== item.id);
      } else if (type === "socialNetwork") {
        this.filterQuery.socialNetwork = this.filterQuery.socialNetwork.filter((n) => n.id !== item.id);
      } else if (type === "tag") {
        this.filterQuery.tag = this.filterQuery.tag.filter((t) => t.id !== item.id);
      } else if (type === "department") {
        this.filterQuery.department = this.filterQuery.department.filter((d) => d.id !== item.id);
      }
    },
    resetFilter() {
      this.filterQuery = {
        coordinator: [],
        socialNetwork: [],
        tag: [],
        department: [],
        noDepartment: false,
        createdDateRange: { startDate: null, endDate: null },
        postDateRange: { startDate: null, endDate: null },
        filterByCreatedDate: false,
        filterByPostDate: false,
      };
    },
    onTagSearch(query) {
      if (!query || query.length < 2) return;
      this.isTagsLoading = true;
      this.$http.post("searchTags", { query: query }).then((response) => {
        this.tagOptions = response.data || [];
        this.isTagsLoading = false;
      }).catch(() => { this.isTagsLoading = false; });
    },
    getInitials(name) {
      if (!name) return "";
      let parts = name.split(" ");
      return parts.map((p) => p.charAt(0)).join("").toUpperCase().substring(0, 2);
    },
    getStatusColor(post) {
      return post.publish_status ? post.publish_status.color : "#778899";
    },
    getCaption(post, returnCount) {
      if (!post.social_posts || !post.social_posts.length) return returnCount ? 0 : "";
      let lang = this.showPostContentLang;
      let net = this.showPostContentNetwork;
      let posts = post.social_posts.filter((sp) => sp.lang_id === lang);
      for (let i = 0; i < posts.length; i++) {
        if (posts[i].caption && posts[i].social_networks && posts[i].social_networks.includes(net)) {
          if (returnCount) return posts[i].caption.length;
          let caption = posts[i].caption;
          if (caption.length > this.captionMaxLength) {
            caption = caption.substr(0, this.captionMaxLength);
            let lastSpace = caption.lastIndexOf(" ");
            if (lastSpace > 0) caption = caption.substr(0, lastSpace);
            caption += "...";
          }
          return caption;
        }
      }
      return returnCount ? 0 : "";
    },
    getThumbnailHtml(post) {
      if (!post.social_posts || !post.social_posts.length) return "";
      let lang = this.showPostContentLang;
      let net = this.showPostContentNetwork;
      let html = "";
      let posts = post.social_posts.filter((sp) => sp.lang_id === lang);
      let placeholderFilename = process.env.MIX_APP_URL + "images/sm-calendar-placeholder.svg";
      for (let i = 0; i < posts.length; i++) {
        if (posts[i].files && posts[i].social_networks && posts[i].social_networks.includes(net)) {
          for (let j = 0; j < posts[i].files.length; j++) {
            let f = posts[i].files[j];
            html += '<img src="' + this.apiUrl + "viewFileSocialMediaPostResized/thumbnail/" + posts[i].id + "/" + f.id + "/" + this.token + "/" + f.file_name + '" alt="' + (f.alt_text || "") + '" onerror="this.onerror=null; this.src=\'' + placeholderFilename + '\'" />';
            // if (!f.alt_text) {
            //   html += "<span class='not-set'>No Alt Text</span>";
            // } else {
            //   html += "<span class='has-content'>" + f.alt_text + "</span>";
            // }
          }
        }
      }
      return html;
    },
    getSocialNetworkClassByIdLocal(id) {
      return this.$store.getters.getSocialNetworkClassById(id);
    },
    getSocialNetworkTypeByIdLocal(id) {
      return this.$store.getters.getSocialNetworkTypeById(id);
    },
    getLangCodeByIdLocal(id) {
      return this.$store.getters.getLangCodeById(id);
    },
    getSocialNetworkClassLocal(apiType) {
      if (apiType === "twitter") return "x-twitter";
      return apiType;
    },
    getSocialNetworkColorClass(network, post) {
      if (!post || !post.social_posts) return "no-content";
      let hasCap = false;
      let hasMissing = false;
      for (let i = 0; i < post.social_posts.length; i++) {
        let sp = post.social_posts[i];
        if (sp.social_networks && sp.social_networks.includes(network)) {
          let currentCap = false;
          if (sp.caption) { hasCap = true; currentCap = true; }
          if (sp.files && sp.files.length > 0) {
            for (let j = 0; j < sp.files.length; j++) {
              if (!sp.files[j].alt_text) hasMissing = true;
            }
          }
          if (!currentCap) hasMissing = true;
        }
      }
      return hasMissing ? "no-content" : "has-content";
    },
    getLangColorClass(langId, post) {
      if (!post || !post.social_posts) return "no-content";
      let hasMissing = false;
      for (let i = 0; i < post.social_posts.length; i++) {
        let sp = post.social_posts[i];
        if (sp.lang_id === langId) {
          let currentCap = false;
          if (sp.caption) currentCap = true;
          if (!currentCap) hasMissing = true;
          if (sp.files && sp.files.length > 0) {
            for (let j = 0; j < sp.files.length; j++) {
              if (!sp.files[j].alt_text) hasMissing = true;
            }
          }
        }
      }
      return hasMissing ? "no-content" : "has-content";
    },
  },

};
</script>

<style lang="scss" scoped>
#dupPostSelectionModal{
  padding: 20px;
  .selection-btn-group{
    margin: 0 30px 0 0;
    button{
      border-radius: .55rem;
      width: 60px;
    }
  }
}
/* Match #editOrganicSocialMediaPlanModal header/body CSS */
#dupPostSelectionModal .modal-header {
  display: none;
}
#dupPostSelectionModal .modal-body {
  padding-bottom: 16px;
}
#dupPostSelectionModal .modal-dialog {
  max-width: 90vw;
  width: 90vw;
  margin: 10px auto;
}
#dupPostSelectionModal .deliverable-listing {
  max-width: 100% !important;
  overflow-x: auto;
}
#dupPostSelectionModal .deliverable-listing .deliverable-block:last-child {
  margin-bottom: 0 !important;
}

#dupPostSelectionModal .dup-post-header-controls {
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
#dupPostSelectionModal .dup-post-header-controls .top-search {
  max-width: 200px;
}
#dupPostSelectionModal .post-content-switcher-wrapper .switch-toggle .btn {
  min-width: 30px;
  height: 30px;
}
#dupPostSelectionModal .list-deliverable-status-bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-left: 4px solid;
}
#dupPostSelectionModal .deliverable-listing .dtable .dtr.listing-row {
  cursor: pointer;
}
#dupPostSelectionModal .deliverable-listing .dtable .dtr.listing-row.dup-item-selected {
  background-color: #e8f4fd;
}
#dupPostSelectionModal .deliverable-listing .dtable .dtr.listing-row .dtd.titles {
  position: relative;
}

/* Series row (master + children inline) */
#dupPostSelectionModal .deliverable-listing .dtable .dtr.top-row .dtd.info-heading.publish-date,
#dupPostSelectionModal .deliverable-listing .dtable .dtr.listing-row .dtd.publish-date,
#dupPostSelectionModal .deliverable-listing .dtable .dtr.listing-row.is-social-series .dtd.publish-date {
  width: 110px !important;
  min-width: 110px !important;
  max-width: 110px !important;
}
#dupPostSelectionModal .deliverable-listing .dtable .dtr.listing-row.is-social-series {
  align-items: stretch;
}
#dupPostSelectionModal .deliverable-listing .dtable .dtr.listing-row.is-social-series .dtd {
  border-bottom: none;
}
#dupPostSelectionModal .deliverable-listing .dtable .dtr.listing-row.is-social-series::after {
  content: '';
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #ddd;
}
#dupPostSelectionModal .deliverable-listing .dtable .dtr.listing-row.is-social-series {
  position: relative;
}
#dupPostSelectionModal .dup-series-post-count-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
#dupPostSelectionModal .dup-series-post-count {
  max-width: 80px;
  height: 32px;
  padding: 2px 8px;
  font-weight: 700;
}
#dupPostSelectionModal .dup-series-post-count-total {
  font-weight: 400;
  padding-bottom: 0;
  white-space: nowrap;
}
</style>
